import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const defaultButton = (props) => <button {...props}>{props.children}</button>;

export default class Pagination extends React.Component {
  constructor(props) {
    super();
    this.changePage = this.changePage.bind(this);
    this.filterPages = this.filterPages.bind(this);
    this.getVisiblePages = this.getVisiblePages.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages),
      rowsPerpage:  props.pageSize || 5,
      dropdownOpen: false,
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages),
      });
    }

    this.changePage(nextProps.page + 1);
  }

  filterPages(visiblePages, totalPages) {
    return visiblePages.filter((page) => page <= totalPages);
  }

  getVisiblePages(page, total) {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  }

  changePage(page) {
    const activePage = this.props.page + 1;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages),
    });

    this.props.onPageChange(page - 1);
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const { visiblePages } = this.state;
    const { getPaginationProps } = this.props;
    if (getPaginationProps) {
      this.data = getPaginationProps();
    }
    const offset = this.props.page * this.props.pageSize;
    const limit =
      this.props.pageSize * this.props.page + this.props.pageSize - offset;
    const newArray = this.props.data.slice();
    const dataPerPage = newArray.splice(offset, limit);
    const options = [
      {
        value: 5,
      },
      {
        value: 10,
      },
      {
        value: 25,
      },
      {
        value: 50,
      },
      {
        value: 100,
      },
    ];
    const activePage = this.props.page + 1;

    return (
      <div className="page">
        <div className="rowsper-page">
          <p>Rows Per Page:</p>
          <Dropdown
            className="page-dropdown"
            isOpen={this.state.dropdownOpen}
            toggle={this.toggle}
          >
            <DropdownToggle caret>{this.state.rowsPerpage}</DropdownToggle>
            <DropdownMenu>
              {options.map((item,index) => {
                return (
                  <DropdownItem
                   key = {`id_${index}`}
                    onClick={() => {
                      this.setState({
                        rowsPerpage: item.value,
                      });
                      this.data.setPageSize(item.value);
                    }}
                  >
                    {item.value}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="page-items">
          <p>
          {this.props.data.length > 0 && <label> {1 + this.state.rowsPerpage * (activePage - 1)}-
            {dataPerPage.length + this.state.rowsPerpage * (activePage - 1)} of{" "}
            {this.props.data.length} items</label>}
            <PageButtonComponent
              className="Table__pageButton fa fa-angle-left arrow-btns"
              onClick={() => {
                if (activePage === 1) return;
                this.changePage(activePage - 1);
                this.data.setPageNo(this.props.page - 1 )
              }}
              disabled={activePage === 1}
            ></PageButtonComponent>
            <PageButtonComponent
              className="Table__pageButton fa fa-angle-right arrow-btns"
              onClick={() => {
                if (activePage === this.props.pages) return;
                this.changePage(activePage + 1);
                this.data.setPageNo(this.props.page + 1 )

              }}
              disabled={activePage === this.props.pages || this.props.data.length === 0}
            ></PageButtonComponent>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Pagination.js